import CSS from 'csstype';
import { debounce } from 'lodash-es';
import React, { useEffect, useMemo, useState } from 'react';

import { borderRadius, Div, fontSizing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  fullWidth?: boolean;
  handleOnChange: (number: number) => void;
  value?: string;
  inputStyle?: CSS.Properties;
  max?: number;
  min?: number;
  msDelay?: number; // add delay to debounce. default 0. recommended 300 or 500 if needing debounce
  placeholder?: string;
  width?: CSS.WidthProperty<string | 0> | undefined;
  isAutoFocused?: boolean;
  key: string; // MUST BE UNIQUE
  inputID: string;
  isDisabled?: boolean;
}

export const FormBuilderNumberInput = ({
  fullWidth,
  handleOnChange,
  isAutoFocused,
  value,
  max = 999999,
  min = 0,
  msDelay = 0,
  placeholder,
  width = '64px',
  inputStyle,
  inputID,
  isDisabled = false,
}: IProps) => {
  const [input, setInput] = useState(value || 0);

  useEffect(() => {
    setInput(value || 0);
  }, [value]);

  const debouncedOnChange = useMemo(() => {
    return debounce(handleOnChange, msDelay);
  }, [handleOnChange]);

  const onChange = (value: number) => {
    setInput(value);
    debouncedOnChange(value);
  };

  return (
    <Div style={{ width: fullWidth ? '100%' : width }}>
      <Div style={{ width: '100%' }}>
        <input
          autoFocus={isAutoFocused}
          className='form-builder-number-input'
          type='number'
          placeholder={placeholder}
          value={input}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            e.stopPropagation();
            e.preventDefault();
            onChange(Number(e.currentTarget.value));
          }}
          min={min}
          max={max}
          style={{
            background: publicaColors.white,
            boxShadow: 'none',
            border: `1px solid ${publicaColors.lightGray}`,
            borderRadius: borderRadius.small,
            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
            padding: '6px',
            width: '100%',
            height: '32px',
            fontSize: fontSizing.small,
            ...inputStyle,
          }}
          id={`${inputID}-formbuilder-text-input`}
          disabled={isDisabled}
        />
      </Div>
    </Div>
  );
};
